$(".g-TileItem").each(function(num,ele){
        if($(ele).find(".g-TileImage .s7responsiveContainer").length == 0){
            $(ele).find(".g-TileItemContent").addClass("noSiblingImage");
        }
});